/*@flow*/
import { useEffect } from 'react';
import { q } from 'ops';
import useStoreState from 'lib/useStoreState';
import * as db from 'lib/db';
import useBrowserQuery from './useBrowserQuery';

const key = '__FILTERS__';

export function clearStorage() {
  db.writeJson(key, {});
}

export default function useFilterLocalStorageSync() {
  const query = useBrowserQuery();
  const storeState = useStoreState({
    started: '$queryInitialized',
  });

  // Read filters from localStorage
  useEffect(() => {
    const savedQuery = db.readJson(key);
    // Do not override current browser filter.
    if (query.hasIn(['filter'])) return;
    savedQuery && q(savedQuery);
  }, [query]);

  // Write filters to localStorage
  useEffect(() => {
    if (storeState.started && query) {
      // Omit bbox from saved filters.
      db.writeJson(key, query.toJS());
    }
  }, [query, storeState.started]);
}
